module.exports = __webpack_public_path__ + "static/media/11_plantilla_menu_logo_cc_blanco.9d5840cc.png";